import React from "react";

export default function TabBar({ tabs, activeTab, onChange }) {
  return (
    <div className="flex border-b border-bookish-purple/15 mb-3">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`flex-1 px-3 py-2 text-xs font-semibold tracking-wide transition-colors ${
            activeTab === tab.key
              ? "text-bookish-purple border-b-2 border-bookish-purple"
              : "text-bookish-purple/50 hover:text-bookish-purple/80"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
